module.exports = __webpack_public_path__ + "static/media/press-header.8e261ac5.jpg";